import { Component, OnInit } from '@angular/core';
import { SpecialPagesService } from '../services/special-pages.service';
import { ApiConnectionService } from '../services/api-connection.service'
import { TranslateServiceService } from '../services/translate-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dynamic-pages',
  templateUrl: './dynamic-pages.component.html',
  styleUrls: ['./dynamic-pages.component.scss']
})
export class DynamicPagesComponent implements OnInit {

	raceId: string;
  arePageReady: boolean = false;
  currentUrl: string = '';
  languageDefault = 'ES';
  constructor(
    private specialPagesService: SpecialPagesService,
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private router: Router
  ) {
  	let _ = this;
    router.events.subscribe((val) => {
      if(_.getKindPage() == 'dynamic'){
        _.arePageReady = false;
        _.getQuantities();
        _.getCurrentPage();
      }
    });
  }

  ngOnInit() {
  	let _ = this;
    window.scrollTo(0, 0)
		_.getQuantities();
    _.getCurrentPage();
  }

  getCurrentPage(){
    const _ = this,
          splitedUrl = _.router.url.split('/'),
          pageUrl = splitedUrl[4];

    _.currentUrl = pageUrl;
    _.redirectToRightPage(pageUrl, splitedUrl);
  }

  redirectToRightPage(url, splitedUrl){
    const _ = this;
    let isEN = _.translateService.getCurrentLanguage(_.languageDefault) === 'EN';

    // English Page Validation
    if(isEN && url == 'la_causa'){
      location.href = `${splitedUrl[0]}/${splitedUrl[1]}/${splitedUrl[2]}/${splitedUrl[3]}/the_cause`
    }

    if(isEN && url == 'como_funciona'){
      location.href = `${splitedUrl[0]}/${splitedUrl[1]}/${splitedUrl[2]}/${splitedUrl[3]}/how_it_works`
    }

    // Spanish Page Validation
    if(!isEN && url == 'the_cause'){
      location.href = `${splitedUrl[0]}/${splitedUrl[1]}/${splitedUrl[2]}/${splitedUrl[3]}/la_causa`
    }

    if(!isEN && url == 'how_it_works'){
      location.href = `${splitedUrl[0]}/${splitedUrl[1]}/${splitedUrl[2]}/${splitedUrl[3]}/como_funciona`
    }
  }

  getKindPage(){
  	let _ = this;
  	let pageUrl: any = location.href.split('/');
  	return pageUrl[5];
  }

  getPageUrl(){
  	let _ = this;
  	let pageUrl: any = location.href.split('/');
  	return pageUrl[6];
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getPages(){
    let _ = this;
    let conditions = {
      "conditions":{
      	"url": _.getPageUrl()
      },
      "race_id": _.raceId,             // Mandatory field
      "merchant": _.getMerchant(),
    }
    _.apiService.getPages(conditions).subscribe(data => {
			let getDynamicPage = document.querySelector('.dynamic-pages-wrapper');
			getDynamicPage.innerHTML =  data['results'][0].html;
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
    })
  }

  getQuantities(){
    let _ = this;
    let conditions = {
     "conditions":{
       "race_url": _.getRaceName(),
       "active": true,
     },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.raceId = data['results'][0].race_id;
      _.arePageReady = true;
    })
  }

}
